/** Consulta el balance vigente de la empresa (CA5b) y su histórico de ventas declaradas (CA21). */
export class LoadCurrentBalanceAction {
  static readonly type = '[FinancingRequestForm] LoadCurrentBalanceAction';
  constructor() {}
}

/** Sube el balance y espera el análisis por IA (CA7 / CA8). */
export class UploadBalanceAction {
  static readonly type = '[FinancingRequestForm] UploadBalanceAction';
  constructor(public payload: { file: File }) {}
}

/**
 * Confirma o corrige el período de cierre (CA10 / CA12 / CA13).
 * PROVISORIO: solo se guarda en el front; todavía no se confirma contra el backend.
 */
export class SetBalancePeriodAction {
  static readonly type = '[FinancingRequestForm] SetBalancePeriodAction';
  constructor(public payload: { period: string }) {}
}

/** "Reemplazar": vuelve a la carga de archivo, cancelando cualquier análisis en curso. */
export class ReplaceBalanceAction {
  static readonly type = '[FinancingRequestForm] ReplaceBalanceAction';
  constructor() {}
}

/** Cancela el reemplazo y vuelve al balance que ya estaba cargado. */
export class CancelReplaceBalanceAction {
  static readonly type = '[FinancingRequestForm] CancelReplaceBalanceAction';
  constructor() {}
}

/** CA5a: "No tengo balance todavía". */
export class DeclareNoBalanceYetAction {
  static readonly type = '[FinancingRequestForm] DeclareNoBalanceYetAction';
  constructor(public payload: { noBalanceYet: boolean }) {}
}

/** Limpia el estado al salir de la pantalla (y cancela el polling en curso). */
export class ResetFinancingRequestFormAction {
  static readonly type = '[FinancingRequestForm] ResetFinancingRequestFormAction';
  constructor() {}
}
